import React from 'react'
import PropTypes from 'prop-types'

import styled, { css } from 'styled-components'
import { layout, space } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import Image from 'Components/UI/_Legacy/Image'

import noop from 'lodash/noop'

const strokeCss = props =>
  props.stroke &&
  css`
    stroke: ${themeGet(`colors.${props.stroke}`)};
  `

const fillCss = props =>
  props.fill &&
  css`
    fill: ${themeGet(`colors.${props.fill}`)};
  `

const shouldForwardProp = prop => {
  return !['shift'].includes(String(prop))
}

const StyledIcon = styled.div.attrs({ as: 'svg' }).withConfig({
  shouldForwardProp,
})`
  vertical-align: middle;
  flex-shrink: 0;

  ${strokeCss};
  ${fillCss};

  ${layout};
  ${space};
`

const Icon = ({ glyph = noop, src, ...rest }) => {
  if (!!glyph) {
    return <StyledIcon {...rest}>{glyph()}</StyledIcon>
  }
  return <Image src={src} {...rest} alt="" />
}

Icon.displayName = 'Icon'

Icon.defaultProps = {
  glyph: noop,
  size: null,
  src: '',
  width: null,
  height: null,
  stroke: null,
}

Icon.propTypes = {
  glyph: PropTypes.func,
  height: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  size: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ]),
  src: PropTypes.string,
  stroke: PropTypes.string,
  width: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]),
}

export default Icon
